import axios from "axios";

import type { Team } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export const getCompanyTeams = queryOptions({
	async queryFn() {
		const response = await axios.get<Team[]>(`${env.apiUrl}/teams/company`);

		return response.data;
	},
	queryKey: "teams",
});

export const deleteTeamById = async ({ id }: { id: string }) => {
	await axios.delete(`${env.apiUrl}/teams/${id}`);

	return;
};

export const updateTeamById = async (team: Partial<Team>) => {
	const response = await axios.put<Team>(`${env.apiUrl}/teams/${team.id}`, team);

	return response.data;
};

export const createTeam = async (team: Partial<Team>) => {
	const response = await axios.post<Team>(`${env.apiUrl}/teams`, team);

	return response.data;
};
